import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConnectionService } from '../../../services/connection/connection.service';
import { Partner } from '../../partner/models/partner';
import { ScanCard } from '../../vu/models/scan-card';
import { PartnerCodeTransaction } from '../models/partner-code-transaction';
import { ScanPartnerCodeInfo } from '../models/scan-partner-code-info';

@Injectable()
export class PartnerCodeService {

  constructor(
    private connectionService: ConnectionService,
  ) {
  }

  getPartnerInfo(card: ScanCard): Observable<ScanPartnerCodeInfo> {
    return this.connectionService.sendJsonPostRequest(`/api/partner_code/info`, {
      code: card.cardID,
      personalNumber: card.personalNumber,
    }).pipe(
      map(result => {
        if (result  && result.error) {
          throw Error(result.error);
        }
        return new ScanPartnerCodeInfo(
          Partner.createFromAny(result),
          card,
          result ? !!result.new_card : true,
          result ? !!result.personalNumberExist : false,
        );
      }),
    );
  }

  registerCard(card: ScanCard, activate: boolean): Observable<Partner> {
    return this.connectionService.sendJsonPostRequest(`/api/partner_code/register_card_for_partner`, {
      code: card.cardID,
      personalNumber: card.personalNumber,
      activate: activate,
    }).pipe(map(result => Partner.createFromAny(result)));
  }

  create(partner: Partner, partnerCode: string, pin: string): Observable<Partner> {
    const data = partner.toJSON();
    data.code = partnerCode;
    data.password = pin;
    return this.connectionService.sendJsonPostRequest(`/api/partner_code/create`, data)
      .pipe(map(result => Partner.createFromAny(result)));
  }

  checkPin(partnerCode: string, pin: string): Observable<boolean> {
    return this.connectionService.sendJsonPostRequest(`/api/partner_code/check_pin`, {
      code: partnerCode,
      pin: pin
    });
  }

  partnerAccountPayment(amountToPay: number): Observable<string> {
    return this.connectionService.sendJsonPostRequest(`/api/partner_code/partner_account_payment`, {
      amountToPay: amountToPay,
    });
  }

  getPartnerCodeTransactions(): Observable<PartnerCodeTransaction[]> {
    return this.connectionService.sendJsonPostRequest('/api/partner-code/transactions', {})
      .pipe(map(result => result.map(x => PartnerCodeTransaction.createFromAny(x))));
  }
}
